import { Component, Input } from '@angular/core';
import { SchoolHeaderComponent } from '../school-header/school-header.component';
import { CompanyEnum } from '../../models/company.model';
import { AyaSchoolsByCountryTable, AyaSchoolTableView } from '../../models';
import { AyaPriceListLinksComponent } from '../aya-price-list-links/aya-price-list-links.component';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-aya-school-header',
  templateUrl: './aya-school-header.component.html',
  imports: [SchoolHeaderComponent, AyaPriceListLinksComponent],
})
export class AyaSchoolHeaderComponent {
  @Input() group: AyaSchoolsByCountryTable | undefined;
  @Input() school: AyaSchoolTableView | undefined;

  protected readonly CompanyEnum = CompanyEnum;
}
